import React, { Component } from "react";
// import {
//     Badge
// } from 'reactstrap';
//Icons
import EditIcon from "react-icons/lib/md/edit";
// import CheckIcon from 'react-icons/lib/md/check';
// import ClearIcon from 'react-icons/lib/md/clear';

import ToolTipItem from "../utils/tooltip";
import { Table, Th, Thead, Tr, Td } from "reactable";
import ServerPaginatedTable from "../utils/pagination.server";

const AirlineLocationTableStructure = ({ data, editCallback }) => (
  <div>
    <Table
      className="table table-striped table-hover"
      id="table"
      sortable={true}
    >
      <Thead>
        <Th column="AirlineName">
          <span>Airline Name</span>
        </Th>
        <Th column="AirportName">
          <span>Airport Name</span>
        </Th>
        <Th column="MinDailyPaxCount">
          <span>Min. Daily Passenger Count</span>
        </Th>
        <Th column="MaxDailyPaxCount">
          <span>Max. Daily Passenger Count</span>
        </Th>
        <Th column="MinMonthlyPaxCount">
          <span>Min. Monthly Passenger Count</span>
        </Th>
        <Th column="MaxMonthlyPaxCount">
          <span>Max. Monthly Passenger Count</span>
        </Th>
        <Th column="MinDailyFlightCount">
          <span>Min. Daily Flight Count</span>
        </Th>
        <Th column="MaxDailyFlightCount">
          <span>Max. Daily Flight Count</span>
        </Th>
        <Th column="MinMonthlyFlightCount">
          <span>Min. Monthly Flight Count</span>
        </Th>
        <Th column="MaxMonthlyFlightCount">
          <span>Max. Monthly Flight Count</span>
        </Th>
        <Th column="Action">Action</Th>
      </Thead>

      {data.map((item, i) => (
        <Tr key={i}>
          <Td column="AirlineName" className="text-capitalize">
            {item.AirlineName}
          </Td>
          <Td column="AirportName">{item.AirportName}</Td>
          <Td column="MinDailyPaxCount">{item.MinDailyPaxCount}</Td>
          <Td column="MaxDailyPaxCount">{item.MaxDailyPaxCount}</Td>
          <Td column="MinMonthlyPaxCount">{item.MinMonthlyPaxCount}</Td>
          <Td column="MaxMonthlyPaxCount">{item.MaxMonthlyPaxCount}</Td>
          <Td column="MinDailyFlightCount">{item.MinDailyFlightCount}</Td>
          <Td column="MaxDailyFlightCount">{item.MaxDailyFlightCount}</Td>
          <Td column="MinMonthlyFlightCount">{item.MinMonthlyFlightCount}</Td>
          <Td column="MaxMonthlyFlightCount">{item.MaxMonthlyFlightCount}</Td>

          <Td column="Action">
            <span
              className="text-primary pointer"
              onClick={e => editCallback(item)}
            >
              <ToolTipItem
                key={i + "edit"}
                title={<EditIcon size="15" color="#43a8df" />}
                content="Edit record"
                id={i + "edit"}
              />
            </span>
          </Td>
        </Tr>
      ))}
    </Table>
  </div>
);

class AirlineLocationTable extends Component {
  render() {
    let { data, editCallback, pageSize, currentPage, totalCount, pageDataCallback } = this.props;
    return (
      <div>
        <ServerPaginatedTable
          currentPage={currentPage}
          fetchMore={pageDataCallback}
          target={
            <AirlineLocationTableStructure
              editCallback={editCallback}
              data={data}
            />
          }
          pageSize={pageSize}
          totalCount={totalCount}
        />
      </div>
    );
  }
}
export default AirlineLocationTable;



// WEBPACK FOOTER //
// ./src/views/airline-location/airline-location-table.js